import moment from 'moment';

const getPeriodOptions = () => {
  const today = moment();
  const startOfToday = today.clone().startOf('day');

  const currentPeriodStart = today.date() >= 16 ? today.clone().date(16).startOf('day') : today.clone().subtract(1, 'month').date(16).startOf('day');

  const options = [];
  for (let i = 0; i < 12; i++) {
    const start = currentPeriodStart.clone().add(i, 'months');
    const end = start.clone().add(1, 'month').subtract(1, 'day');
    const label = `${start.format('MMMM YYYY')} - ${end.format('MMMM YYYY')}`;
    const value = start.format('YYYY-MM');
    const isDisabled = end.isBefore(startOfToday);
    options.push({ label, value, isDisabled });
  }
  return options;
};

export default getPeriodOptions;
